const initReceiver = (grid, canvas, getTransform, callbacks) => {
    let lastHoverUV = [-1000, -1000];

    const transformCoordinates = (x, y) => {
        const matrix = getTransform().invertSelf();
        return {
            x: matrix.a * x + matrix.c * y + matrix.e,
            y: matrix.b * x + matrix.d * y + matrix.f,
        };
    };

    canvas.addEventListener('click', e => {
        const coords = transformCoordinates(e.offsetX, e.offsetY);
        if (e.button === 0) {
            const uv = grid.getCoordinatesAt(coords.x, coords.y);
            if (uv !== undefined && callbacks.click) {
                callbacks.click(uv[0], uv[1]);
            }
        }
    });

    canvas.addEventListener('mousemove', e => {
        const coords = transformCoordinates(e.offsetX, e.offsetY);
        const uv = grid.getCoordinatesAt(coords.x, coords.y);
        if (uv !== undefined && (uv[0] !== lastHoverUV[0] || uv[1] !== lastHoverUV[1])) {
            callbacks.hover(uv[0], uv[1]);
            lastHoverUV = uv;
        }
    });
}

export default initReceiver;
